<template>
  
</template>

<script>
export default {
  data() {
    return {
      canvas: {
        width: 0,
        height: 0,
      },
    }
  },
  computed: {
      k3DA() {
        return '大'
      },
      k3XIAO() {
        return '小'
      },
      k3DAN() {
        return '单'
      },
      k3SHUANG() {
        return '双'
      },
      lineChartShow() {
          return this.$store.state.trend.lineChartShow;
      },
      missNumberShow() {
          return this.$store.state.trend.missNumberShow;
      },
      statisticalShow() {
        return this.$store.state.trend.statisticalShow;
      },
      lotteryNumbTypeCode() {
        return this.$store.state.trend.lotteryNumbTypeCode;
      },
      // 表头号码
      lotteryNumbHead() {
        if (this.lotteryNumbTypeCode.length == 0) return [];
        return this.getLotteryNumbHeadArr(this.lotteryNumbTypeCode);
      },
      // 表头和值组合形态
      lotteryTotalGroupHead() {
        if (this.lotteryNumbTypeCode.length == 0) return [];
        return this.getLotteryTotalGroupHeadArr(this.lotteryNumbTypeCode);
      },
      // 表头号码形态
      lotteryNumStatusHead() {
        if (this.lotteryNumbTypeCode.length == 0) return [];
        return this.getLotteryNumStatusHeadArr(this.lotteryNumbTypeCode);
      },
      // 开奖数组
      lotteryTrendList() {
        return this.$store.getters["trend/lotteryTrendList"]
      },
      // 开奖结果数组
      openNumbArr() {
        let list = []
        this.lotteryTrendList.forEach(obj => {
          list.push(obj.drawingNumber.split(','))
        })
        return list
      },
      // 开奖结果数组反转
      reverseOpenNumArr() {
        const originArr = JSON.parse(JSON.stringify(this.openNumbArr))
        return originArr.reverse()
      },
      // 开奖号码分开单列数组
      openNumSperateArr() {
        return this.$store.getters["trend/openNumSperateArr"];
      },
      // 开奖号码单列走势
      openNumSperateTrendList() {
        //走势列表
        let list = [];
        this.openNumSperateArr.forEach((e) => {
          list.push(this.chartListNormal(this.lotteryNumbHead, e));
        });
        return list;
      },
      // 开奖号码单列统计
      openNumSperateStatisticaList() {
        let list = [];
        this.openNumSperateTrendList.forEach((e) => {
          list.push(this.statistica(this.lotteryNumbHead, e));
        });
        return list;
      },
      // 开奖结果走势列表
      opendNumTableList() {
        return this.chartList(this.openNumbArr)
      },
      // 开奖结果统计
      openNumStatisticaList() {
        return this.statistica(this.lotteryNumbHead,this.opendNumTableList)
      },
      // 开奖和值数组
      lotteryTrendTotalArr() {
        return this.$store.getters["trend/lotteryTrendTotalArr"];
      },
      // 单双比
      dsb() {
        let arr = []
        this.openNumbArr.forEach((numArr, index) => {
          let dashu = 0
          let shuangshu = 0
          numArr.forEach(numStr => {
            if(parseInt(numStr) % 2 === 0) {
              shuangshu += 1
            } else {
              dashu += 1
            }
          })
          arr[index] = `${dashu}:${shuangshu}`
        })
        return arr
      },
  },
  methods: {
      drawArrayCanvas(openNumSperateTrendList = this.openNumSperateTrendList) {
        // console.log('openNumSperateTrendList', openNumSperateTrendList)
        let list = this.getArrayChartCoordinate(openNumSperateTrendList);
        if(!list) {
          return;
        }
        const ctx = this.$refs.trendCanvas.getContext("2d");
        ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        list.forEach((coordinateList, index) => {
          ctx.beginPath();
          ctx.lineWidth = 2;
          ctx.strokeStyle = "#f53f00";
          for (let i = 0, len = coordinateList.length; i + 1 < len; i++) {
            ctx.moveTo(coordinateList[i][0], coordinateList[i][1]);
            ctx.lineTo(coordinateList[i + 1][0], coordinateList[i + 1][1]);
          }
          ctx.stroke();
        });
      },
      // 表头开奖码
      getLotteryNumbHeadArr(typeCode) {
        switch (typeCode) {
          case "11X5":
            return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
            break;
          case "K3":
            return [1, 2, 3, 4, 5, 6];
            break;
          case "PK10":
            return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
            break;
          case "SSC":
            return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
            break;
          case "PCDD":
            return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
            break;
          case "PL3":
            return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
            break;
          case "3D":
            return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
            break;
          case "LHC":
            return ['正码一', '正码二', '正码三', '正码四', '正码五', '正码六', '特码'];
            break;
          case "ZHISHU":
            return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
            break;
          case "SSQ":
            return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33];
            break;
          case "DLT":
            return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35];
            break;
          default:
            break;
        }
      },
      // 表头和值码
      getLotteryTotalHeadArr(typeCode) {
        switch (typeCode) {
          case 'K3':
            return [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18];
            break;
          case '3D':
            return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27];
            break;
          case 'PL3':
            return  [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27];
            break;
          case 'PCDD':
            return  [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27];
            break;
          case '11X5':
            return  [];
            break;
          case 'SSC':
            return  [];
            break;
          case 'PK10':
            return  [];
            break;
          case 'LHC':
            return  [];
            break;
          case "ZHISHU":
            return [];
            break;
          case "SSQ":
            return [];
            break;
          case "DLT":
            return [];
            break;
          default:
            break;
        }
      },
      // 表头和值形态
      getLotteryTotalGroupHeadArr(typeCode) {
        switch(typeCode) {
          case 'K3':
            return [`${this.k3XIAO}${this.k3DAN}`, `${this.k3XIAO}${this.k3SHUANG}`, `${this.k3DA}${this.k3DAN}`, `${this.k3DA}${this.k3SHUANG}`];
            break;
          case '3D':
            return [];
            break;
          case 'PL3':
            return [];
            break;
          case 'PCDD':
            return [];
            break;
          case '11X5':
            return [];
            break;
          case 'SSC':
            return [];
            break;
          case 'LHC':
            return [];
            break;
          case 'PK10':
            return [];
            break;
          case 'ZHISHU':
            return [];
            break;
          case 'SSQ':
            return [];
            break;
          case 'DLT':
            return [];
            break;
          default:
            break;
        }
      },
      // 表头号码形态
      getLotteryNumStatusHeadArr(typeCode) {
        switch(typeCode) {
          case 'K3':
            return ['三同号', '三不同号', '三连号', '二同号(复)','二同号(单)','二不同号'];
            break;
          case '3D':
            return [];
            break;
          case 'PL3':
            return [];
            break;
          case 'PCDD':
            return [];
            break;
          case '11X5':
            return [];
            break;
          case 'SSC':
            return ['5:0', '4:1', '3:2', '2:3', '1:4', '0:5'];
            break;
          case 'LHC':
            return [];
            break;
          case 'PK10':
            return [`${this.k3DAN}`, `${this.k3SHUANG}`, `${this.k3DA}`, `${this.k3XIAO}`, '质', '合', '0', '1', '2'];
            break;
          case 'ZHISHU':
            return [];
            break;
          case 'SSQ':
            return [];
            break;
          case 'DLT':
            return [];
            break;
          default:
            break;
        }
      },
      // 和值形态
      getTotalGroupArr(typeCode) {
        let firstName = ''
        let lastName = ''
        switch(typeCode) {
          case 'K3':
            return this.lotteryTrendTotalArr.map(item => {
              item >= 11 ? firstName = `${this.k3DA}` : firstName = `${this.k3XIAO}`
              item % 2 == 0 ? lastName = `${this.k3SHUANG}` : lastName = `${this.k3DAN}`
              return firstName + lastName
            })
            break;
          default:
            break;
        }
      },
      // 号码形态
      getNumStatusArr(typeCode) {
        switch(typeCode) {
          case 'K3':
            return this.openNumbArr.map(numArr => {
              let arr = Array.apply(null, Array(6)).map(() => '')
              if(numArr.every(num => Number(num) === Number(numArr[0]))) {
                arr[0] = '三同号'
              }
              if(Number(numArr[0]) !== Number(numArr[1])
                 && Number(numArr[0]) !== Number(numArr[2])
                 && Number(numArr[1]) !== Number(numArr[2])
              ) {
                arr[1] = '三不同号'
              }
              if(Number(numArr[0]) + 1 === Number(numArr[1])
                && Number(numArr[1]) + 1 === Number(numArr[2])
              ) {
                arr[2] = '三连号'
              }
              if((Number(numArr[0]) === Number(numArr[1])
                || Number(numArr[1]) === Number(numArr[2]))
                && Number(numArr[0]) !== Number(numArr[2])
              ) {
                arr[3] = '二同号(复)'
                arr[4] = '二同号(单)'
              }
              if(!numArr.every(num => Number(num) === Number(numArr[0]))
              ) {
                arr[5] = '二不同号'
              }
              return arr
            })
            break;
          default:
            break;
        }
      },
      // 计算出现的次数
      counts(arr, value) {
        return arr.reduce((a, v) => v === value ? a + 1 : a + 0, 0)
      },
      // 计算最大连出
      maxContinuitys(arr) {
        let columnStr = arr.toString();
        let matchArr = columnStr.replace(/,/g, "").match(/(A)\1*/g);
        let max = 0
        if (matchArr == null) {
          return max
        } else {
          matchArr.forEach((e) => {
            if (e.length > max && (e.length - 1 > 0)) {
              max = e.length;
            }
          })
          return max
        }
      },
      // 计算平均遗漏
      averageMissArrs(arr) {
        const totalLength = this.openNumbArr.length
        let columnStr = arr.toString();
        let colsArr = columnStr.split(/A/g);
        if((colsArr.length - 1) === 0) {
          return 0
        } else {
          return parseInt(totalLength / (colsArr.length - 1))
        }
      },
      // 计算最大遗漏
      maxMissArrs(arr) {
        let columnStr = arr.toString();
        let colsArr = columnStr.split(/A/g);
        let max = 0
        let maxArr = []
        colsArr.forEach((e) => {
          let arr = e.split(",");
          max = Math.max.apply(Math, arr);
          maxArr.push(max);
        })
        return Math.max.apply(Math, maxArr)
      },
      // 计算号码形态走势
      chartNumStatusList(lotteryNumStatusHead,numStatusArr) {
        if(!lotteryNumStatusHead || !numStatusArr) {
          return;
        }
        if (numStatusArr.length == 0) return [];
        let list = []
        const singleLength = lotteryNumStatusHead.length
        const allLength = numStatusArr.length
        const originArr = JSON.parse(JSON.stringify(numStatusArr))
        const reverseArr = originArr.reverse()
        let totalArr = Array.apply(null, Array(singleLength)).map(() => 0)
        const hitPosition = 'A'
        for(let i = 0; i < allLength; i++) {
          let arr = []
          i == 0 ? (arr = totalArr) : (arr = [...list[i - 1]])
          // 内层循环生产单行数据
          for(let k = 0; k < singleLength; k++) {
            arr[k] === hitPosition ? (arr[k] = 1) : (arr[k] += 1)
          }
          let runtimes = reverseArr[i].length
          for(let m = 0;m < runtimes; m++) {
            let index = lotteryNumStatusHead.indexOf(reverseArr[i][m])
            arr[index] = 'A'
          }
          list.push(arr)
        }
        return list.reverse()
      },
      // 计算和值走势,和值组合走势
      chartTotalList(lotteryTotalHead,lotteryTrendTotalArr) {
        if(!lotteryTotalHead || !lotteryTrendTotalArr) {
          return;
        }
        if (lotteryTrendTotalArr.length == 0) return [];
        let list = []
        const singleLength = lotteryTotalHead.length // 单行数组长度
        const allLength = lotteryTrendTotalArr.length // 30个，50个，100个，数据总长度
        const originArr = JSON.parse(JSON.stringify(lotteryTrendTotalArr))
        const reverseArr = originArr.reverse()
        let totalArr = Array.apply(null, Array(singleLength)).map(() => 0) // [0, 0, 0, 0, 0, 0]
        const hitPosition = 'A'
        // 外层循环数据总长度
        for(let i = 0; i < allLength; i++) {
          let arr = []
          i == 0 ? (arr = totalArr) : (arr = [...list[i - 1]])
          // 内层循环生产单行数据
          for(let k = 0; k < singleLength; k++) {
            arr[k] === hitPosition ? (arr[k] = 1) : (arr[k] += 1)
          }
          arr[lotteryTotalHead.indexOf(reverseArr[i])] = 'A'
          list.push(arr)
        }
        return list.reverse()
      },
      // 计算快三开奖结果走势
      chartList(openNumbArr, lotteryNumbHead = this.lotteryNumbHead) {
        if (openNumbArr.length == 0) return [];
        let list = []
        const singleLength = lotteryNumbHead.length
        const allLength = this.openNumbArr.length
        const originArr = JSON.parse(JSON.stringify(openNumbArr))
        const reverseArr = originArr.reverse()
        let initArr = Array.apply(null, Array(singleLength)).map(() => 0)
        const hitOnePosition = 'A'
        const hitTwoPostion = 'B'
        const hitThreePositon = 'C'
        for(let i = 0; i < allLength; i++) {
          let arr = []
          i == 0 ? (arr = initArr) : (arr = [...list[i - 1]])
          for(let k = 0; k < singleLength; k++) {
            arr[k] === hitOnePosition || arr[k] === hitTwoPostion || arr[k] === hitThreePositon
            ? arr[k] = 1
            : arr[k] += 1
          }
          const runtimes = reverseArr[i].length
          for(let m = 0;m < runtimes; m++) {
            let index = lotteryNumbHead.indexOf(Number(reverseArr[i][m]))
            if(arr[index] == 'A') {
              arr[index] = 'B'
            } else if(arr[index] == 'B') {
              arr[index] = 'C'
            } else {
              arr[index] = 'A'
            }
          }
          list.push(arr)
        }
        return list.reverse()
      },
      // 非快三号码单列开奖结果走势
      chartListNormal(lotteryNumbHead, lotteryOpenNumbArr) {
        if (lotteryOpenNumbArr.length == 0) return [];
        //根据今日开奖的数据 计算每期每个球 多久未中奖
        if(!lotteryNumbHead) {
          return;
        }
        let list = [];
        let lotteryNumbLen = lotteryNumbHead.length // [0,1,2,3,4,5,6]
        let lotteryListLen = lotteryOpenNumbArr.length; // 30个，50个，100个
        const originArr = JSON.parse(JSON.stringify(lotteryOpenNumbArr))
        const reverseArr = originArr.reverse()
        //获得基础次数
        let numbList = Array.apply(null, Array(lotteryNumbLen)).map(() => 0);

        //console.log(this.lotteryOpenNumbArr)
        //循环计算每期数字的未中奖的次数
        let openFlag = "A";
        for (let i = 0; i < lotteryListLen; i++) {
          let arr = [];
          i == 0 ? (arr = numbList) : (arr = [...list[i - 1]]);

          for (let k = 0; k < lotteryNumbLen; k++) {
            arr[k] == openFlag ? (arr[k] = 1) : (arr[k] += 1);
          }
          //this.lotteryOpenNumbArr[i]：当期中奖号码
          arr[lotteryNumbHead.indexOf(Number(reverseArr[i]))] = "A";

          list.push(arr);
        }
        return list.reverse();
      },
      // 开奖结果统计
      statistica(headArr, trendTableList) {
        if (trendTableList.length == 0) return [];
        // 总期数
        const totalLength = trendTableList.length
        //统计列表
        let columnArr = [];
        //出现次数
        let countArr = [];
        //平均遗漏
        let averageMissArr = [];
        //最大遗漏
        let maxMissArr = [];
        //最大连出
        let maxContinuity = [];
        headArr.forEach((element, index) => {
          let list = []
          trendTableList.forEach((e, i) => {
            if(e[index] === 'B' || e[index] === 'C') {
              list.push('A')
            } else {
              list.push(e[index])
            }
          })
          columnArr.push(list)
        })
        columnArr.forEach((column, index) => {
          // 计算最大连出
          let columnStr = column.toString();
          let matchArr = columnStr.replace(/,/g, "").match(/(A)\1*/g);
          let max = 0;
          if (matchArr == null) {
            maxContinuity.push(0);
          } else {
            matchArr.forEach((e) => {
              if (e.length > max && (e.length - 1 > 0)) {
                max = e.length;
              }
            });
            maxContinuity.push(max);
          }
          let colsArr = columnStr.split(/A/g);
          //出现次数
          countArr.push(colsArr.length - 1);
          // 平均遗漏
          let count = 0;
          let maxArr = [];
          colsArr.forEach((e) => {
            let arr = e.split(",");
            let max = Math.max.apply(Math, arr);
            count += max;
            maxArr.push(max);
          });
          //平均遗漏
          averageMissArr.push(parseInt(totalLength / colsArr.length));
          //最大遗漏
          maxMissArr.push(Math.max.apply(Math, maxArr));
        })
        return {
          countArr, //出现次数
          averageMissArr, //平均遗漏
          maxMissArr, //最大遗漏
          maxContinuity, //最大连出
        };
      },
  }
}
</script>

<style>

</style>